import React from "react";
import TextAnimation from "./TextAnimation";
import LoadingIllustration from "./LoadingIllustration";
import LoadingCompleteIllustration from "./LoadingCompleteIllustration";

const ScoringLoadingModal = ({isLoadingComplete}: {isLoadingComplete: boolean}) => {
  return (
    <div
      className="fixed left-0 top-0 z-50 flex h-screen w-screen flex-col items-center justify-center gap-4 bg-white"
      data-testid="scoring-loading-modal"
    >
      {!isLoadingComplete ? (
        <>
      <TextAnimation />
      <LoadingIllustration />
      </>
      ): (
      <LoadingCompleteIllustration />
      )}
    </div>
  );
};

export default ScoringLoadingModal;
